import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import axios from "axios";
import { BASE_URL } from "utils/constant";

const RaiseNewTicketModal = ({ open, onClose, onSuccess }) => {
  const [issueHeader, setIssueHeader] = useState("");
  const [issueDescription, setIssueDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    if (!issueHeader || !issueDescription) {
      setMessage("Please fill in all required fields.");
      return;
    }

    const formData = new FormData();
    const orgId = JSON.parse(localStorage.getItem("organization"))?.id;
    formData.append("org", orgId);
    formData.append("issue_header", issueHeader);
    formData.append("issue_description", issueDescription);
    if (attachment) {
      formData.append("attachments", attachment);
    }

    try {
      setSubmitting(true);
      const res = await axios.post(`${BASE_URL}/org/create/ticket/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      console.log("✅ Ticket Created:", res.data); // ✅ Now works

      setMessage("");
      setIssueHeader("");
      setIssueDescription("");
      setAttachment(null);
      onSuccess();
    } catch (error) {
      console.error(error);
      setMessage(
        error.response?.data?.detail ||
          "Failed to raise ticket. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: 20,
          fontFamily: "Outfit, sans-serif",
        }}
      >
        Raise New Ticket
      </DialogTitle>

      <DialogContent dividers>
        {message && (
          <Typography
            color="error"
            variant="body2"
            sx={{ mb: 2, fontFamily: "Outfit, sans-serif" }}
          >
            {message}
          </Typography>
        )}

        <TextField
          fullWidth
          required
          label="Issue Title"
          placeholder="E.g. Unable to access reports module"
          value={issueHeader}
          onChange={(e) => setIssueHeader(e.target.value)}
          sx={{ mb: 3, fontFamily: "Outfit, sans-serif" }}
        />

        <TextField
          fullWidth
          required
          label="Issue Description"
          placeholder="Explain the issue..."
          multiline
          rows={4}
          value={issueDescription}
          onChange={(e) => setIssueDescription(e.target.value)}
          sx={{ mb: 3, fontFamily: "Outfit, sans-serif" }}
        />

        <Box>
          <Typography
            variant="subtitle2"
            sx={{ mb: 1, fontFamily: "Outfit, sans-serif" }}
          >
            Attachment (optional)
          </Typography>
          <input
            type="file"
            onChange={(e) => setAttachment(e.target.files[0])}
            accept=".jpg,.png,.pdf,.doc,.docx"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 999,
            textTransform: "none",
            color: "#3B0069",
            borderColor: "#3B0069",
            "&:hover": {
              borderColor: "#3B0069",
              backgroundColor: "#f3e9ff",
            },
          }}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={submitting}
          sx={{
            backgroundColor: "#3B0069",
            borderRadius: 999,
            textTransform: "none",
            px: 4,
            "&:hover": { backgroundColor: "#3B0069" },
          }}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RaiseNewTicketModal;
